import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const THRESHOLD = 70;
const MAX = 110;

// Custom pull-to-refresh so it works even when the app is installed (standalone/PWA),
// where the browser's native pull-to-refresh is disabled.
export function PullToRefresh() {
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(null);
  const active = useRef(false);

  useEffect(() => {
    const onStart = (e) => {
      if (window.scrollY <= 0 && e.touches.length === 1) {
        startY.current = e.touches[0].clientY;
        active.current = true;
      } else {
        active.current = false;
      }
    };
    const onMove = (e) => {
      if (!active.current || startY.current == null || refreshing) return;
      const dy = e.touches[0].clientY - startY.current;
      if (dy > 0 && window.scrollY <= 0) {
        const dist = Math.min(dy * 0.5, MAX);
        setPull(dist);
      } else {
        setPull(0);
      }
    };
    const onEnd = () => {
      if (!active.current) return;
      active.current = false;
      if (pull >= THRESHOLD && !refreshing) {
        setRefreshing(true);
        setPull(THRESHOLD);
        setTimeout(() => window.location.reload(), 300);
      } else {
        setPull(0);
      }
      startY.current = null;
    };
    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchmove", onMove, { passive: true });
    window.addEventListener("touchend", onEnd, { passive: true });
    return () => {
      window.removeEventListener("touchstart", onStart);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onEnd);
    };
  }, [pull, refreshing]);

  const visible = pull > 0 || refreshing;

  return (
    <div
      data-testid="pull-to-refresh"
      aria-hidden={!visible}
      className="fixed left-0 right-0 top-0 z-[60] flex justify-center pointer-events-none"
      style={{ transform: `translateY(${visible ? pull - 10 : -40}px)`, transition: active.current ? "none" : "transform 0.25s ease" }}
    >
      <div className="mt-2 w-9 h-9 rounded-full bg-[#FDFBF7] border border-[#D9D4CC] shadow-sm flex items-center justify-center">
        <RefreshCw
          className={`w-4 h-4 text-[#2C2A29] ${refreshing ? "animate-spin" : ""}`}
          style={{ transform: refreshing ? "none" : `rotate(${pull * 2.4}deg)` }}
        />
      </div>
    </div>
  );
}
